import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");
  
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3>TercumanApp</h3>
            <ul className="footer-links">
              <li>
                <Link to={isEnglish ? "/en" : "/"}>
                  {isEnglish ? "Home" : "Ana Sayfa"}
                </Link>
              </li>
              <li>
                <Link to={isEnglish ? "/en/pricing" : "/fiyatlandirma"}>
                  {isEnglish ? "Pricing" : "Fiyatlandırma"}
                </Link>
              </li>
              <li>
                <a href="#about">{isEnglish ? "About Us" : "Hakkımızda"}</a>
              </li>
              <li>
                <a href="#careers">{isEnglish ? "Careers" : "Kariyer"}</a>
              </li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3>{isEnglish ? "Product" : "Ürün"}</h3>
            <ul className="footer-links">
              <li>
                <a href="#features">{isEnglish ? "Features" : "Özellikler"}</a>
              </li>
              <li>
                <a href="#use-cases">{isEnglish ? "Use Cases" : "Kullanım Alanları"}</a>
              </li>
              <li>
                <a href="#demo">{isEnglish ? "Request Demo" : "Demo Talep Et"}</a>
              </li>
              <li>
                <a href="#trial">{isEnglish ? "Free Trial" : "Ücretsiz Deneme"}</a>
              </li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3>{isEnglish ? "Resources" : "Kaynaklar"}</h3>
            <ul className="footer-links">
              <li>
                <a href="#docs">{isEnglish ? "Documentation" : "Dokümantasyon"}</a>
              </li>
              <li>
                <a href="#faq">{isEnglish ? "FAQ" : "SSS"}</a>
              </li>
              <li>
                <a href="#blog">{isEnglish ? "Blog" : "Blog"}</a>
              </li>
              <li>
                <a href="#support">{isEnglish ? "Support" : "Destek"}</a>
              </li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3>{isEnglish ? "Legal" : "Yasal"}</h3>
            <ul className="footer-links">
              <li>
                <a href="#terms">{isEnglish ? "Terms of Service" : "Kullanım Şartları"}</a>
              </li>
              <li>
                <a href="#privacy">{isEnglish ? "Privacy Policy" : "Gizlilik Politikası"}</a>
              </li>
              <li>
                <a href="#cookies">{isEnglish ? "Cookie Policy" : "Çerez Politikası"}</a>
              </li>
              <li>
                <a href="#gdpr">{isEnglish ? "GDPR" : "KVKK"}</a>
              </li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3>{isEnglish ? "Contact" : "İletişim"}</h3>
            <ul className="footer-links">
              <li>
                <a href="mailto:info@tercumanapp.com">info@tercuman.app</a>
              </li>
              <li>
                <a href="#location">
                  {isEnglish ? "Istanbul, Turkey" : "İstanbul, Türkiye"}
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} TercumanApp. {isEnglish ? "All rights reserved." : "Tüm hakları saklıdır."}
          </p>
        </div>
      </div>
    </footer>
  );
}
